import { BotIcon } from 'lucide-react'
import { type ReactNode, useMemo } from 'react'

import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { cn } from '@/lib/utils'

const THINKING_PHRASE_LIST = [
  'Thinking...',
  'Pondering...',
  'Contemplating...',
  'Figuring it out...',
  'Zig-zagging through ideas...',
  'Connecting the dots...',
  'Crunching the numbers...',
  'Consulting the oracle...',
  'Reading between the lines...',
  'Untangling the threads...',
  'Spinning up neurons...',
  'Processing...',
  'Researching...',
  'Investigating...',
  'Exploring possibilities...',
  'Brewing thoughts...',
  'Assembling insights...',
  'Mining for answers...',
  'Navigating the maze...',
  'Chasing a hunch...',
  'Putting pieces together...',
  'Following the breadcrumbs...',
  'Diving deep...',
  'Wandering through ideas...',
  'Cooking up a response...',
  'Calibrating thoughts...',
  'Sifting through data...',
  'Decoding the puzzle...',
  'Synthesizing...',
  'Summoning wisdom...',
  'Herding cats...',
  'Quantum thinking...',
] as const

export interface ChatThoughtIndicatorProps {
  className?: string
}

export const ChatThoughtIndicator: React.FC<ChatThoughtIndicatorProps> = ({
  className,
}): ReactNode => {
  const thinkingPhrase = useMemo(
    () => THINKING_PHRASE_LIST[Math.floor(Math.random() * THINKING_PHRASE_LIST.length)],
    []
  )

  return (
    <div className={cn('chat-thought-indicator flex items-center gap-2 py-2', className)}>
      <Avatar className="size-8">
        <AvatarFallback className="bg-primary text-primary-foreground">
          <BotIcon className="size-4" />
        </AvatarFallback>
      </Avatar>

      <span className="animate-thinking-shimmer text-xs font-medium">{thinkingPhrase}</span>
    </div>
  )
}

ChatThoughtIndicator.displayName = 'ChatThoughtIndicator'
